import { useNavigate } from 'react-router';
import { Button, type ButtonSize } from './Button';

interface FormActionsProps {
  /** Where Cancel returns to. */
  cancelTo: string;
  submitLabel: string;
  submitting?: boolean | undefined;
  /** Patient registration uses a large primary button. */
  submitSize?: ButtonSize | undefined;
}

/**
 * The Cancel / Save pair that ends every form.
 *
 * It sits at page level rather than in a card footer. The six forms were split
 * three-and-three between the two placements, so the save button lived on a
 * grey rail on some screens and floated below the last card on others. Only the
 * page-level bar works for both single- and multi-card forms, so it is the one
 * rule that covers every form the app will grow.
 */
export function FormActions({
  cancelTo,
  submitLabel,
  submitting,
  submitSize = 'md',
}: FormActionsProps) {
  const navigate = useNavigate();

  return (
    <div className="c-form-actions">
      <Button onClick={() => void navigate(cancelTo)}>Cancel</Button>
      <Button type="submit" variant="primary" size={submitSize} loading={submitting}>
        {submitLabel}
      </Button>
    </div>
  );
}
